import { defineMessages } from 'react-intl';

export default defineMessages({
    paymentHeader: {
        id: 'tdic.portal.components.transactionWizardTitle.transactionWizardTitle.Policy Change - PL',
        defaultMessage: 'Policy Change - Homeowners'
    },
    accountTitleHo: {
        id: 'tdic.endorsement.directives.templates.bank-account-details-quote.Account:',
        defaultMessage: 'Account:'
    },
    plPolicyChange: {
        id: 'tdic.endorsement.pl.directives.templates.pl-policy-changes.Type Of Changes',
        defaultMessage: 'Type Of Changes'
    },
    hoPolicyChangeQuotes: {
        id: 'tdic.endorsement.common.views.history.Quote',
        defaultMessage: 'Quote'
    },
    hoPolicyChangePayments: {
        id: 'tdic.endorsement.ho.directives.templates.ho-coverages.Payments',
        defaultMessage: 'Payments'
    },
    anErrorOccurred: {
        id: 'tdic.gw-portals-policytransaction-pc-ho.wizard.error',
        defaultMessage: 'Something went wrong during this process.'
    },
    anErrorOccurredTitle: {
        id: 'tdic.gw-portals-policytransaction-pc-ho.wizard.error.title',
        defaultMessage: 'Error'
    },
    saveQuoteError: {
        id: 'tdic.gw-portals-policytransaction-pc-ho.Unable to quote',
        defaultMessage: 'Unable to quote'
    },
    saveQuoteErrorMessage: {
        id: 'tdic.gw-portals-policytransaction-pc-ho.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.'
    }
});
